;(function () {
  'use strict'

  angular
    .module('deskfy.arts')
    .factory('ScheduleArtShareService', scheduleArtShareService)

  /* @ngInject */
  function scheduleArtShareService (ConnectorWebService, CONSTANTS, Utils) {
    const service = {
      getScheduledArtsShare,
      createScheduledArtShare,
      updateScheduledArtShare,
      deleteScheduledArtShare,
      getSchedulesByArt
    }

    return service

    function getScheduledArtsShare (top, skip) {
      const url = Utils.fnAddTopSkipQueriesToUrl(CONSTANTS.URL_SCHEDULED_SHARE, top, skip)
      return ConnectorWebService.get(url)
    }

    function createScheduledArtShare (payload) {
      return ConnectorWebService.post(CONSTANTS.URL_SCHEDULED_SHARE, payload)
    }

    function updateScheduledArtShare (id, payload) {
      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_SCHEDULED_SHARE_ID, [id])
      return ConnectorWebService.put(url, payload)
    }

    function deleteScheduledArtShare (id) {
      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_SCHEDULED_SHARE_ID, [id])
      return ConnectorWebService.fnDelete(url)
    }

    function getSchedulesByArt (artId) {
      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_SCHEDULED_SHARE_ART_ID, [artId])
      return ConnectorWebService.get(url)
    }
  }
})()
